import { ButchUserEditModal } from 'pages/admin/components/ButchUserEditModal';

export const ButchUserEdit: React.FC = () => <ButchUserEditModal />;
